import React from "react";
import Select from "react-select";
import { agents, counties, propertyTypes } from "./filterOptions";
import { CURRENT_YEAR, DATASETS, DEFAULT_FILTERS, money } from "./propertyData";

export default function Filter({ filters, onChange, onApply, onReset, error }) {
  const selection = (key, label, options) => (
    <div className="field">
      <label htmlFor={key}>{label}</label>
      <Select
        inputId={key}
        isMulti
        options={options.filter((o) => o.value !== "all")}
        value={options.filter(
          (o) => filters[key].includes(o.value) && o.value !== "all"
        )}
        placeholder={`All ${label.toLowerCase()}`}
        classNamePrefix="select"
        onChange={(values) =>
          onChange(key, values?.length ? values.map((o) => o.value) : ["all"])
        }
      />
    </div>
  );
  const range = (label, low, high, min, max, step = 1) => (
    <fieldset>
      <legend>{label}</legend>
      <div className="range">
        {[low, high].map((key, i) => (
          <label key={key} htmlFor={key}>
            <span>{i === 0 ? "From" : "To"}</span>
            <input
              id={key}
              type="number"
              min={min}
              max={max}
              step={step}
              value={filters[key]}
              onChange={(e) => onChange(key, e.target.value)}
            />
          </label>
        ))}
      </div>
    </fieldset>
  );
  return (
    <form
      className="filters"
      onSubmit={(e) => {
        e.preventDefault();
        onApply();
      }}
    >
      <div className="section-heading">
        <h2>Find properties</h2>
        <button type="button" className="text-button" onClick={onReset}>
          Reset
        </button>
      </div>
      <div className="field">
        <label htmlFor="dataset">Explore</label>
        <select
          id="dataset"
          value={filters.dataOption}
          onChange={(e) => onChange("dataOption", e.target.value)}
        >
          {Object.entries(DATASETS).map(([value, dataset]) => (
            <option key={value} value={value}>
              {dataset.label}
            </option>
          ))}
        </select>
      </div>
      {selection("filterCounties", "Counties", counties)}
      {range("Year range", "startYear", "endYear", 2010, CURRENT_YEAR)}
      <fieldset className="price-filter">
        <legend>
          {filters.dataOption === "rentals" || filters.dataOption === "shares"
            ? "Advertised rent (€)"
            : "Price range (€)"}
        </legend>
        <div className="range">
          <label htmlFor="minPrice">
            <span>Minimum</span>
            <input
              id="minPrice"
              type="number"
              min="0"
              max={DEFAULT_FILTERS.maxPrice}
              step="1"
              placeholder="No minimum"
              value={Number(filters.minPrice) === 0 ? "" : filters.minPrice}
              onChange={(e) =>
                onChange("minPrice", e.target.value === "" ? 0 : e.target.value)
              }
            />
          </label>
          <label htmlFor="maxPrice">
            <span>Maximum</span>
            <input
              id="maxPrice"
              type="number"
              min="0"
              max={DEFAULT_FILTERS.maxPrice}
              step="1"
              placeholder="No maximum"
              value={
                Number(filters.maxPrice) === DEFAULT_FILTERS.maxPrice
                  ? ""
                  : filters.maxPrice
              }
              onChange={(e) =>
                onChange(
                  "maxPrice",
                  e.target.value === ""
                    ? DEFAULT_FILTERS.maxPrice
                    : e.target.value
                )
              }
            />
          </label>
        </div>
        <div className="price-presets" role="group" aria-label="Price presets">
          {(filters.dataOption === "rentals"
            ? [1000, 2000, 3000]
            : filters.dataOption === "shares"
            ? [500, 1000, 1500]
            : [250000, 500000, 750000]
          ).map((price) => (
            <button
              key={price}
              type="button"
              aria-pressed={
                Number(filters.maxPrice) === price &&
                Number(filters.minPrice) === 0
              }
              onClick={() => {
                onChange("minPrice", 0);
                onChange("maxPrice", price);
              }}
            >
              Up to {money(price)}
            </button>
          ))}
          <button
            type="button"
            aria-pressed={Number(filters.maxPrice) === DEFAULT_FILTERS.maxPrice}
            onClick={() => onChange("maxPrice", DEFAULT_FILTERS.maxPrice)}
          >
            No maximum
          </button>
        </div>
      </fieldset>
      <details>
        <summary>More filters</summary>
        {selection("filterPropertyTypes", "Property types", propertyTypes)}
        {range("Bedrooms", "minBeds", "maxBeds", 0, 100)}
        {selection("filterAgents", "Agents", agents)}
        <p className="muted">
          For sales, bedroom, type and agent filters only include properties
          with matching listings.
        </p>
      </details>
      {error && (
        <p role="alert" className="error">
          {error}
        </p>
      )}
      <button type="submit" className="primary">
        Show results
      </button>
    </form>
  );
}
